module.exports = __webpack_public_path__ + "img/login.a568162c.svg";